<template>
  <div>
    <b-modal id="email" ref="modal" title="Change Email" @ok="handleOk" ok-title="Update Email">
      <p>
        1. Enter your <strong>new</strong> email address below. <br />2. Also enter
        <strong>current</strong> your password.
      </p>
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="Email"
          label-for="email-input"
          invalid-feedback="Email address is required."
          :state="emailState"
        >
          <b-form-input
            id="email-input"
            v-model="email"
            :state="emailState"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Password"
          label-for="password-input"
          invalid-feedback="Password is required"
        >
          <b-form-input
            id="password-input"
            v-model="password"
            type="password"
            required
          ></b-form-input>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'

import { handleGlobalError } from '../../util'

export default {
  data() {
    return {
      email: '',
      emailState: null,
      password: '',
    }
  },
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.emailState = valid
      return valid
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    async handleSubmit() {
      try {
        await axios.post(`${process.env.VUE_APP_PXL_API}/authmanagement`, {
          action: 'identityChange',
          value: {
            user: { email: this.$store.getters.user.email },
            password: this.password,
            changes: { email: this.email },
          },
        })
        // alert(JSON.stringify(user))
        this.successToast()
      } catch (error) {
        console.error('error trying to change email', error)
        handleGlobalError(this, error, 'change email')
      }
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('email')
      })
    },
    successToast() {
      this.$bvToast.toast('We have sent an email to verify your new email', {
        title: 'Verify Email',
        variant: 'success',
        solid: true,
        toaster: 'b-toaster-top-center',
      })
    },
  },
}
</script>
<style scoped>
.btn-cancel {
  color: #fff;
  background-color: rgb(213, 213, 213);
  border-color: rgb(213, 213, 213);
}
</style>
